/**
 * AnnouncementBanner
 * -------------------
 * Non-blocking strip pinned to the top of the app. Dismissible per
 * session (per-user + per-version so an edit resurfaces it).
 */
import { X, Megaphone } from "lucide-react";

export default function AnnouncementBanner({ announcement: a, onDismiss }) {
  return (
    <div
      className="w-full flex items-center gap-3 px-4 py-2 text-white shadow"
      style={{ background: "linear-gradient(90deg,#032866,#0866FF)" }}
      data-testid="announcement-banner"
    >
      {a._isTest && (
        <span
          className="text-[9px] font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wider whitespace-nowrap"
          style={{ background: "#FEE68B", color: "#8A5A00" }}
        >
          TEST
        </span>
      )}
      <span
        className="text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider"
        style={{ background: "#FFDA00", color: "#032866" }}
      >
        <Megaphone className="w-3 h-3 inline-block -mt-0.5 mr-1" />
        {a.title}
      </span>
      <span className="text-xs md:text-sm flex-1 truncate">
        {a.message}
      </span>
      <button
        type="button"
        onClick={onDismiss}
        className="text-white/80 hover:text-white p-1 rounded-md hover:bg-white/10 flex-none"
        aria-label="Dismiss announcement"
        data-testid="announcement-banner-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
